import { render, staticRenderFns } from "./UsdtTransaction.vue?vue&type=template&id=61199eb2&"
import script from "./UsdtTransaction.vue?vue&type=script&lang=ts&"
export * from "./UsdtTransaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UsdtTransaction.vue"
export default component.exports